<!-- No Data Template -->
<ng-template #no_data_template>
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeNoDataText">
          {{ 'global.no_data' | translate }}
        </span>
      </div>
    </div>
  </div>
</ng-template>

<!-- Poi Template -->
<ng-template #poi_template
  let-poi="poi">
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentHandleContainer">
        <button medsurf-design-input-button [id]="'poi_handle_' + poi.id"
          [title]="'global.poi_handle' | translate"
          [class]="FlatModels.TreeDesignModels.TreeDragNodeHandleElement"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.HANDLE_TEXT"
        [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MOVE"></button>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentAttributesContainer">
        <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.SIGN_POST"></i>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText">
          {{ poi.name }}
        </span>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentChipContainer">
        <p-tag 
          [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.IMAGE"
          [value]="(poi.images.length || 0).toString()" />
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
        <div class="flex flex-row column-gap-2 w-4rem">
          <div class="flex w-2rem">
            <button medsurf-design-input-button [id]="'poi_go_to_' + poi.id"
              [title]="'global.poi_go_to' | translate"
              [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
              [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.LOCATE"
            (click)="goToPoi(poi)"></button>
          </div>
          <div class="flex w-2rem">
            @if (poi.images.length > 1) {
              <button medsurf-design-input-button
                [id]="'image_poi_remove_' + poi.id"
                [title]="'global.image_poi_remove' | translate"
                [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER_SMALL_OUTLINED"
                [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE"
              (click)="removePoiFromImage(poi)"></button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Content -->
<div class="flex flex-1 flex-column row-gap-2 mb-2">
  <label id="pois_label"
    class="flex flex-grow-1 flex-row column-gap-2">
    <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.SIGN_POST"></i>
    <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
      {{ 'global.pois' | translate }}
    </span>
  </label>
  <div [class]="FlatModels.TreeDesignModels.ItemListContainer">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
      @if (slideAuthorFacade.currentSelectedSlideImage$ | async; as image) {
        @if (slideAuthorFacade.pois$(image.pois) | async | sortBy_shared:'asc':'sequenceNumber'; as pois) {
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
            @if (image.pois.length === 0) {
              <ng-container *ngTemplateOutlet="no_data_template"></ng-container>
            }
            @if (pois.length === 0) {
              @for (i of image.pois; track i) {
                <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
                  class="cursor-wait"
                  >
                </p-skeleton>
              }
            }
            @if (pois.length > 0) {
              <div
                [dragula]="getDragulaKey('image-pois')"
                [dragulaModel]="pois"
                (dragulaModelChange)="onImagePoiMoved($event)">
                @for (poi of pois; track trackByPoi($index, poi)) {
                <ng-container *ngTemplateOutlet="poi_template;context:{
                              poi: poi}">
                  </ng-container>
                }
              </div>
            }
          </div>
        }
      }
    </div>
  </div>

  <!-- Image Poi -->
  @if (imagePoiForm && imagePoiOptionArray && imagePoiOptionArray.length > 0) {
    <medsurf-design-form-control-form
      [formGroup]="imagePoiForm"
      [class]="'w-full'"
      (onSubmit)="onSubmit()">
      <!-- Poi -->
      <medsurf-design-form-control-input-dropdown [formField]="false"
        [control]="imagePoiForm.controls.id"
        [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY_DROPDOWN"
        [menuClass]="FlatModels.PanelDesignModels.MenuDesignClass.SEPARATE_FIRST_ENTRY"
        [class]="'w-full align-self-start'"
        [placeholder]="'global.poi_link'"
        [options]="imagePoiOptionArray"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-dropdown>
    </medsurf-design-form-control-form>
  }
</div>
